'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isSameDate = require('../../date/is-same-date.js');
var addDays = require('../../date/add-days.js');

const computeIntenseCalendar = (card) => {
    const { details } = card;
    const startDate = new Date(details.utcStartDate);
    const endDate = new Date(details.utcEndDate);
    const calculateIntenseCalendarAux = (date, calendar) => {
        if (date > endDate) {
            return calendar;
        }
        const jsDay = date.getDay();
        const day = jsDay === 0 ? 7 : jsDay;
        if (details.enabledWeekDays.includes(day) && !details.disabledDates.includes(date.toISOString().slice(0, 10))) {
            calendar.push(new Date(date));
        }
        date.setDate(date.getDate() + 1);
        return calculateIntenseCalendarAux(date, calendar);
    };
    return calculateIntenseCalendarAux(startDate, []);
};
const computeCurrentSession = (card, forceComputeCalendar) => {
    const { details, achievement } = card;
    if (details.type === 'flexible' && !forceComputeCalendar) {
        return Math.min(achievement.lastSessionPlayed + 1, details.sessionCount);
    }
    const today = new Date();
    if (today <= new Date(details.utcStartDate)) {
        return 1;
    }
    if (today >= new Date(details.utcEndDate)) {
        return details.sessionCount;
    }
    const calendar = computeIntenseCalendar(card);
    const todayDate = today.toISOString().slice(0, 10);
    const currentSession = calendar.findIndex((date) => date.toISOString().slice(0, 10) >= todayDate);
    if (currentSession === -1) {
        throw new Error('Current session not found');
    }
    return Math.min(currentSession + 1, details.sessionCount);
};
const checkTodayPlayable = (card) => {
    const today = new Date();
    const { details } = card;
    const startDate = new Date(details.utcStartDate);
    const endDate = new Date(details.utcEndDate);
    if (today < startDate || today > endDate) {
        return false;
    }
    const jsDay = today.getDay();
    const day = jsDay === 0 ? 7 : jsDay;
    if (!details.enabledWeekDays.includes(day)) {
        return false;
    }
    if (details.disabledDates.includes(today.toISOString().slice(0, 10))) {
        return false;
    }
    return true;
};
const findNextAvailableDate = (currentDate, enabledWeekDays, disabledDates) => {
    if (enabledWeekDays.length === 0)
        return null;
    const dayofDate = currentDate.getDay();
    const isEnabledDay = enabledWeekDays.includes(dayofDate === 0 ? 7 : dayofDate);
    const isDisabledDate = disabledDates.some((d) => isSameDate.isSameDate(d, currentDate));
    if (isEnabledDay && !isDisabledDate) {
        return currentDate;
    }
    return findNextAvailableDate(addDays.addDays(currentDate, 1), enabledWeekDays, disabledDates);
};
const getCalendarSessionDatesFromCampaign = ({ launchDate, enabledWeekDays, disabledDates, nbSessions, extraDays = 0, }) => {
    const sessionCount = nbSessions + extraDays;
    const calendarDatesBySession = Array.from({ length: sessionCount }).reduce((acc, _, index) => {
        const session = index + 1;
        const lastDate = session > 1 ? addDays.addDays(new Date(acc[session - 1]), 1) : new Date(launchDate);
        const nextSessionDate = findNextAvailableDate(lastDate, enabledWeekDays, disabledDates);
        if (!nextSessionDate)
            return acc;
        return Object.assign(Object.assign({}, acc), { [session]: nextSessionDate });
    }, {});
    return calendarDatesBySession;
};

exports.checkTodayPlayable = checkTodayPlayable;
exports.computeCurrentSession = computeCurrentSession;
exports.computeIntenseCalendar = computeIntenseCalendar;
exports.findNextAvailableDate = findNextAvailableDate;
exports.getCalendarSessionDatesFromCampaign = getCalendarSessionDatesFromCampaign;
//# sourceMappingURL=live-campaign.js.map
